var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSettingBigIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 68,
    viewBox: "0 0 68 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\xF0\x9F\xA6\x86 icon \"settings\""
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M33.8228 43.6532C39.1542 43.6532 43.476 39.3315 43.476 34C43.476 28.6686 39.1542 24.3469 33.8228 24.3469C28.4914 24.3469 24.1696 28.6686 24.1696 34C24.1696 39.3315 28.4914 43.6532 33.8228 43.6532Z",
    stroke: "#9E9E9E",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M58.3496 28.8369L54.8175 20.308L59.5646 14.6937L53.1291 8.25826L47.5454 13.03L38.8354 9.44798L36.8323 1.82281H30.5439L28.5107 9.54898L20.0008 13.1362L14.5165 8.25826L8.08104 14.6937L12.7576 20.4497L9.27964 29.0006L1.6456 30.7823V37.2177L9.3717 39.327L12.9583 47.8353L8.08104 53.3063L14.5165 59.7418L20.2799 55.0449L28.6648 58.4943L30.6051 66.1772H37.0405L38.9856 58.4972L47.5145 54.9651C48.9361 55.9812 53.1291 59.7418 53.1291 59.7418L59.5646 53.3063L54.7891 47.6734L58.3222 39.1419L65.9997 37.1444L66 30.7823L58.3496 28.8369Z",
    stroke: "#9E9E9E",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingBigIcon);
export default __webpack_public_path__ + "static/media/setting-big-icon.36d615c18b9b0a0c3fd49ea9fc03dc7c.svg";
export { ForwardRef as ReactComponent };